export default __webpack_public_path__ + "static/media/close.244705f7.svg";